// eslint-disable-next-line import/prefer-default-export
export const userSettings = 'USER_SETTINGS';
export const configTable = 'CONFIG_TABLE';
export const outliers = 'OUTLIERS';
